//import api from '@/api/mock';
import API from '@aws-amplify/api';
export default {
  namespaced: true,
  state: {
    invitation: null
  },
  mutations: {
    set(state, invitation) {
      state.invitation = invitation;
    }
  },
  actions: {
    async load({ commit }, code) {
      let invitation = null;
      invitation = await API.get('ipWayAPI', '/invitations/' + code + '/');
      console.log(invitation);
      commit('set', invitation);
      return invitation;
    },
    async fetch({ dispatch, state }, code) {
      if (state.invitation == null) {
        console.log('fetching invitation data');
        await dispatch('load', code);
      }
      return state.notification;
    },
    async get({ dispatch, state }, code) {
      await dispatch('fetch', code);
      return state.notification;
    },
    ['awsauth/setUser']: {
      root: true,
      handler({ commit }, user) {
        //on logout clear gateway from list
        if (!user) {
          commit('set', null);
        }
      }
    }
  }
};
